import { Button } from '@velocity/ui';
import React from 'react';
import { stripToDigits } from '../../../utils/number-format';
import InputField from '../input-field/input-field';
import styles from './adac-membership.module.css';

interface AdacMembershipProps {
  register: any;
  errors: any;
  setValue: any;
  trigger: any;
}
const AdacMembership: React.FC<AdacMembershipProps> = ({
  register,
  errors,
  setValue,
  trigger,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.membershipText}>ADAC-Mitgliedschaft</span>
      </div>

      <div className={styles.content}>
        <div className={styles.inputSection}>
          <InputField
            className={styles.inputField}
            label='Mitgliedsnummer'
            placeholder='XXXXXXXXX'
            {...register('membership_number')}
            error={errors.membership_number?.message}
            maxLength={9}
            onChange={(e) => {
              const val = stripToDigits(e.target.value, true).slice(0, 9);
              setValue('membership_number', val, { shouldValidate: true });
              trigger('membership_number');
            }}
          />{' '}
        </div>
        <div className={styles.promotionSection}>
          <h3 className={styles.promotionTitle}>Noch kein Mitglied?</h3>
          <p className={styles.promotionText}>
            Du bist noch kein ADAC Mitglied? Jetzt ist die perfekte Gelegenheit!
            Hol dir deine Mitgliedschaft ganz einfach hier über den Link.
          </p>
          <div className='flex justify-end'>
            <Button
              variant='secondary-outlined'
              size='m'
              margin={{ top: '04' }}
              onClick={() =>
                window.open(
                  'https://www.adac.de/mitgliedschaft/?utm_source=ayvens',
                  '_blank',
                )
              }
            >
              Jetzt Mitglied werden
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdacMembership;
